<div class="user-data" [matMenuTriggerFor]="userMenu">
  <mat-icon matBadgeColor="primary">account_circle</mat-icon>
  <span class="username-text" *ngIf="showName">{{userName}}</span>
  <mat-menu #userMenu="matMenu">
    <div class="logged-username"><mat-icon matBadgeColor="primary">account_circle</mat-icon>{{userName}}</div>
    <hr>
    <button mat-menu-item (click)="signOut()">Sair</button>
  </mat-menu>
</div>